const COURSE_TYPES = {
	INITIAL_STATE: 'COURSES/INITIAL_STATE',
	SET: 'COURSES/SET',
	GET_ALL: 'COURSES/GET_ALL',
	SET_ALL: 'COURSES/SET_ALL',
	GET_ONE: 'COURSES/GET_ONE',
	SET_ONE: 'COURSES/SET_ONE',
	CREATE: 'COURSES/CREATE',
	UPDATE: 'COURSES/UPDATE',
	REMOVE: 'COURSES/REMOVE',
	GET_EXAM: 'COURSES/GET_EXAM',
	SET_EXAM: 'COURSES/SET_EXAM',
	SET_ANSWERED_SECTION: 'COURSES/SET_ANSWERED_SECTION',
	SET_USER_ANSWERS: 'COURSES/SET_USER_ANSWERS',
	GET_INSTITUTION_COURSES: 'COURSES/GET_INSTITUTION_COURSES',
	SET_INSTITUTION_COURSES: 'COURSES/SET_INSTITUTION_COURSES',
	GET_USERS_COURSES: 'COURSES/GET_USERS_COURSES',
	SAVE_USERS_COURSES: 'COURSES/SAVE_USERS_COURSES',
	GET_BY_USER: 'COURSES/GET_BY_USER',
	GET_BY_INSTITUTION: 'COURSES/GET_BY_INSTITUTION',
	COURSE_STARTED: 'COURSES/COURSE_STARTED',
	COURSE_FINISHED: 'COURSES/COURSE_FINISHED',
	UPDATE_INSTRUCTIONS: 'COURSES/UPDATE_INSTRUCTIONS',
	GET_REPORT: 'COURSE/GET_REPORT',
	SET_REPORT: 'COURSE/SET_REPORT',
	DOWNLOAD_REPORT: 'COURSES/DOWNLOAD_REPORT',
	GET_EXAM_REVIEW: 'COURSES/GET_EXAM_REVIEW',
	SET_EXAM_REVIEW: 'COURSES/SET_EXAM_REVIEW',
	GET_USER_CERTIFICATE: 'COURSES/GET_USER_CERTIFICATE',
	SET_USER_CERTIFICATE: 'COURSES/SET_USER_CERTIFICATE',
	SET_REVIEW_INSTITUTION: 'COURSES/SET_REVIEW_INSTITUTION',
	SET_REVIEW_COURSE: 'COURSES/SET_REVIEW_COURSE',
	DOWNLOAD_USER_EXAM: 'COURSES/DOWNLOAD_USER_EXAM',
	DOWNLOAD_ALL_USERS_EXAM: 'COURSES/DOWNLOAD_ALL_USERS_EXAM',
	DOWNLOAD_USERS_CERTIFICATE: 'COURSES/DOWNLOAD_USERS_CERTIFICATE',
	DOWNLOAD_USER_CERTIFICATE: 'COURSES/DOWNLOAD_USER_CERTIFICATE',
};

export default COURSE_TYPES;
